import type { CloseableBridgeState, LastFirehoseParams } from '../close-bridge-connection.js';

export function updateFirehoseIdentifyOnOpenConnection(
  state: CloseableBridgeState,
  params: LastFirehoseParams,
): void {
  state.lastFirehoseParams = params;
  state.firehoseHandle?.updateIdentify(params);
}
